import React from 'react';
import ReactDOM from 'react-dom';
// import { timeParse } from 'd3-time';
import { scaleLinear } from 'd3-scale';
import { line, curveCardinal } from 'd3-shape';
import { axisBottom, axisLeft } from 'd3-axis';
import { drag } from 'd3-drag';
import { extent, range } from 'd3-array';
import { select, event } from 'd3-selection';
import { interpolate } from 'd3-interpolate'; // TODO i wish interpolateBasis worked for cardinal
import { linear } from 'everpolate';

import './Spline.css';

// d3-drag 2.0.0 doesn't play nice with react - use v1.2.5

// https://observablehq.com/@d3/spline-editor


const interpolateOnto = (path, points, xF, yF) => {
  /*
    use the DOM's bezier calculation to reuse the interpolation "function"
    similar function to d3-interpolate-curve
  */
  const area = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  area.innerHTML = "<path></path>";
  const svgpath = area.querySelector("path");
  svgpath.setAttribute("d", path);
  const totalLength = svgpath.getTotalLength();

  const curvePoints = range(0, totalLength, totalLength / 100)
    .map(p => svgpath.getPointAtLength(p))

  const xS = curvePoints.map(p => p.x)
  const yS = curvePoints.map(p => yF.invert(p.y))
  const newXs = points.map(p => xF(p.x))
  const yHats = linear(newXs, xS, yS)

  return points.map((p, pi) => {
    return {
      ...p,
      yHat: yHats[pi]
    }
  })

  // TODO xF.domain[1] ?
  // const maxX = xF.range()[1];
  // console.log(maxX, totalLength, minPoint, maxPoint)
  // const vs = points
  //   .map(p => {
  //     console.log(yF.invert(svgpath.getPointAtLength(totalLength * xF(p.x) / maxX).y), p.y, p)
  //     return {
  //       ...p,
  //       yHat: yF.invert(svgpath.getPointAtLength(totalLength * xF(p.x) / maxX).y)
  //     }
  //   })
  // return vs
}

const getSplineData = (curveData, splinePoints) => {
    return [
    curveData[0],
    ...(splinePoints || [curveData[Math.floor(3 * curveData.length / 20)]]),
    curveData[curveData.length - 1],
  ]
}

export default function Spline({ curveData, setSplineData  }) {

  const [splinePoints, setSplinePoints] = React.useState();
  const svgRef = React.useRef(null);


  // set the dimensions and margins of the graph
  var margin = {top: 0, right: 40, bottom: 40, left: 10},
      width = 300 - margin.left - margin.right,
      height = 250 - margin.top - margin.bottom;
      // width = svgRef.current.clientWidth - margin.left - margin.right,
      // height = svgRef.current.clientHeight - margin.top - margin.bottom;

  // const width = 300
  // const height = 150

  // parse the date / time
  // var parseTime = timeParse("%d-%b-%y");

  // set the ranges
  var xF = scaleLinear().range([0, width]);
  var yF = scaleLinear().range([height, 0]);

 // scale the range of the data
  xF.domain(extent(curveData, d => d.x));
  yF.domain(extent(curveData, d => d.y));

  // define the area
  // var areaF = area()
  //     .x(d => x(d.x))
  //     .y0(height)
  //     .y1(d => y(d.y));

  var lineF = line()
      .x(d => xF(d.x))
      .y(d => yF(d.y))

  var curveF = line().curve(curveCardinal)
      .x(d => xF(d.x))
      .y(d => yF(d.y))

  const splineData = getSplineData(curveData, splinePoints)

  React.useEffect(() => {

    const svg = select(svgRef.current)

    //   .append('g')
    //   .attr('transform', `translate(${margin.left}, ${margin.top})`)

    // svg.append('path')
    //   .data([curveData])
    //   .attr('class', 'Spline-line')
    //   .attr('d', lineF)

    // svg.append('path')
    //   .data([splineData])
    //   .attr('class', 'Spline-curve')
    //   .attr('d', curveF)

    // add the X Axis
    // svg.append("g")
    //     .attr("transform", "translate(0," + height + ")")
    //     .call(axisBottom(xF).ticks(4));

    // svg.append("g")
      // .attr("transform", "translate(0," + height + ")")
    //   .call(axisBottom(xF).ticks(4));


    const point = splineData[1]

    const dragF = drag()
        .on('drag', () => {
          const { x, y } = event;
          const xS = Math.max(0, Math.min(x, width));
          const yS = Math.max(0, Math.min(y, height));
          const newP = [{x: xF.invert(xS), y: yF.invert(yS)}]
          setSplinePoints(newP)
          circle.attr('transform', `translate(${xS}, ${yS})`)
          setSplineData(interpolateOnto(curveF(getSplineData(curveData, newP)), curveData, xF, yF))
        })

    const circle = svg.append('circle')
      .attr('class', 'spline-circle')
      .attr('transform', d => `translate(${xF(point.x)}, ${yF(point.y)})`)
      .attr('r', 5)
      .call(dragF)

    // init
    setSplineData(interpolateOnto(curveF(splineData), curveData, xF, yF))

  }, [])

  return <svg className="Spline-Root" >
    <g ref={svgRef} transform={`translate(${margin.left}, ${margin.top})`}>
      <path className="Spline-line" d={lineF(curveData)}/>
      <path className="Spline-curve" d={curveF(splineData)}/>
      <g className="Spline-legend" transform={"translate(0," + height + ")"}>
        {
          curveData.filter((c, ci) => ci === 0 || ci === curveData.length - 1).map((c) => <text
            key={c.SA2_MAIN16}
            transform={`translate(${xF(c.x)}, 0)rotate(90)`}
            >
              {c['Area Name']}
          </text>)
        }
      </g> 
    </g>
  </svg>
  {/* <DragCircle splineData={splineData} x={x} y={y}/>*/}

}

